import React, { useEffect, useState } from 'react';
import {
  Container,
  Paper,
  styled,
  Typography,
} from '@material-ui/core';
import jwtdecode from 'jwt-decode';
import ListAgreements from './list/ListAgreements';
import appPermissions from '../../../helpers/appPermissions';
import Edit from './edit/EditAgreements';
import AgreementDetails from './list/AgreementDetails';
import AddAgreements from './create/AddAgreements';

const getMulishText = (fontWeight, color, fontSize) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize,
  fontWeight,
  color,
});

const messageStyle = (
  theme, firstImageIcon, marginTopImage, minWidth, minHeight, paddingBottom = 15,
) => ({
  firstImage: firstImageIcon,
  styleMessage: {
    ...getMulishText(700, '#575756', '18px'),
    paddingBottom,
  },
  firstImageStyles: {
    display: 'block',
    margin: 'auto',
    marginTop: marginTopImage,
  },
  styleTitle: {
    ...getMulishText(700, theme?.alertPopup?.titleAlert?.color, '20px'),
    marginTop: '-25px',
  },
  dialogStyle: { minWidth, minHeight },
});

const MyPaper = styled(Paper)({
  background: 'linear-gradient(#FFFFFFCC, #ffffff)',
  borderRadius: '30px',
  opacity: 1,
  padding: '5px',
  marginTop: '20px',
});

const MyPaperGroup = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  marginTop: 24,
  marginBottom: 32,
  borderRadius: 10,
  border: `1px solid ${theme.home.cart.discountText.color}`,
  padding: 36,
}));

const MyTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontFamily: 'Mulish',
  fontSize: '34px',
  paddingTop: '32px',
  paddingLeft: '32px',
  color: theme.backOffice?.contracts?.title?.color,
}));

const Agreements = () => {
  const [activeSection, setActiveSection] = useState({ id: 0, section: 'list' });
  const [permissionsApp, setPermissionsApp] = useState(['btnCreateContract', 'modifyContract']);

  useEffect(() => {
    let token = sessionStorage.getItem('appsUserToken');
    token = token.replace('Bearer ', '');
    const user = jwtdecode(token);
    const userPrivileges = user?.LICENSE_PRIVILEGE;
    const permissionForUser = [];
    Object.entries(appPermissions.ModuleAggrements).forEach(([key, permissions]) => {
      const canAccces = permissions?.privileges?.some(
        (privilegeRequired) => userPrivileges.some((userPriv) => userPriv.includes(privilegeRequired)),
      );
      if (canAccces) {
        permissionForUser.push(key);
      }
    });
    setPermissionsApp(permissionForUser);
  }, []);

  if (activeSection?.section === 'edit') {
    return (
      <Edit
        uniqueId={activeSection.id}
        setActiveSection={setActiveSection}
        permissions={permissionsApp}
        messageStyle={messageStyle}
      />
    );
  }

  if (activeSection?.section === 'detail') {
    return (
      <AgreementDetails
        uniqueId={activeSection.id}
        setActiveSection={setActiveSection}
        permissions={permissionsApp}
        messageStyle={messageStyle}
      />
    );
  }

  return (
    <Container
      component="main"
      maxWidth="lg"
    >
      <MyPaper elevation={3}>
        <MyTypography color="primary" variant="h4">
          Convenios
        </MyTypography>
        <Container
          component="main"
          maxWidth="lg"
          style={{
            borderColor: 'red',
          }}
        >
          <MyPaperGroup elevation={3}>
            {(activeSection?.section === 'agregate') && <AddAgreements setActiveSection={setActiveSection} messageStyle={messageStyle} />}
            {(activeSection?.section === 'list') && <ListAgreements setActiveSection={setActiveSection} permissions={permissionsApp} />}
            {(activeSection?.section === 'detail') && <ListAgreements setActiveSection={setActiveSection} permissions={permissionsApp} />}
          </MyPaperGroup>
        </Container>
      </MyPaper>
    </Container>
  );
};

export default Agreements;
